import { useState } from 'react'

import { auth } from 'constants/fireabaseConfig'

import { useCurrentStatusStore } from 'store/currentStatusStore'
import { getAPI } from 'utils/getAPI'

import type { ResponseResult } from 'api-client'
import type { LoginUserWithMfa, MfaUser } from 'types/types'

export const fetchMfaInfo = () => {
  const mfaUser = auth.currentUser as MfaUser
  const mfaInfo = mfaUser?.reloadUserInfo?.mfaInfo

  if (mfaInfo && mfaInfo[0]) {
    return {
      isMfaEnabled: true,
      mfaTel: mfaInfo[0].phoneInfo,
    }
  }

  return {
    isMfaEnabled: false,
    mfaTel: null,
  }
}

export const useLoginUserInfo = () => {
  const [loginUserInfo, setLoginUserInfo] = useState<LoginUserWithMfa | undefined>(undefined)
  const [result, setResult] = useState<ResponseResult>()

  const [isLoading, setIsLoading] = useState(false)

  const { setCurrentStatuses } = useCurrentStatusStore()

  const fetchLoginUserInfo = async () => {
    setIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.readUsersMeLoginUserInfoGet()

      if (response.data) {
        const loginUserWithMfa = {
          ...response.data,
          ...fetchMfaInfo(),
        }

        setLoginUserInfo(loginUserWithMfa)
        setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
      }
      setResult(response.result)
      return response
    } catch (e) {
      const error = e as any
      setResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `ログインユーザ情報取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  return {
    loginUserInfo,
    result,
    setLoginUserInfo,
    setResult,
    fetchLoginUserInfo,
    isLoading,
  }
}
